import { NotificationsApi } from './api'

export const NotificationsStore = {
  Api: NotificationsApi,
}
